"use client"

import { useProductContext } from "../../context"
import { setSelectedVariationByProductId } from "../../state"
import { Tile } from "./Tile"

export const ProductTiles = () => {
  const { id, variations, variationsAreNotColors, selectedVariation } = useProductContext()

  if (!variations || variations.length < 2) {
    return null
  }

  const onlySomeVariantsDiscounted = variations.filter((variation) => variation.discount).length !== variations.length

  return (
    <ul className="-mx-6 flex flex-wrap items-end justify-center gap-2" data-testid="ProductTiles">
      {variations.map((variation) => {
        return (
          <Tile
            key={variation.id}
            name={variation.name}
            available={variation.available}
            image={variation.tileImage}
            regularPrice={variation.regularPrice}
            discount={variation.discount}
            coupon={variation.coupon}
            showTileDiscountHeader={onlySomeVariantsDiscounted}
            variationsAreNotColors={variationsAreNotColors}
            selected={variation.id === selectedVariation?.id}
            onClick={() => setSelectedVariationByProductId(id, variation.id)}
          />
        )
      })}
    </ul>
  )
}
